var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSedanP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sedan",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_20",
    "data-name": "Rect\\xE1ngulo 20",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "car",
    d: "M19.552,10.163H18.131a.314.314,0,0,0-.211.085,9.794,9.794,0,0,0-1.288-1.669c-1.268-1.268-8.874-1.268-10.142,0a9.8,9.8,0,0,0-1.282,1.659.306.306,0,0,0-.195-.074H3.59a.319.319,0,0,0-.317.317v.64a.4.4,0,0,0,.31.376l.862.165a7.966,7.966,0,0,0-.493,5.794v1.228c0,.35.089.634.2.634H5.775c.11,0,.2-.283.2-.634v-1c1.457.139,3.518.292,5.585.292,2.049,0,4.133-.149,5.587-.288v1c0,.35.089.634.2.634h1.624c.109,0,.2-.283.2-.634V17.455a7.965,7.965,0,0,0-.491-5.79l.882-.168a.4.4,0,0,0,.31-.376v-.64a.316.316,0,0,0-.315-.317ZM5.934,15.315a1.149,1.149,0,0,1,0-2.3,1.149,1.149,0,0,1,0,2.3Zm-.966-3.29a10.466,10.466,0,0,1,1.97-3c.37-.371,2.117-.765,4.623-.765s4.252.395,4.623.766a10.41,10.41,0,0,1,1.969,3c-1.352.149-3.984-.2-6.591-.2s-5.24.346-6.592.2Zm12.217,3.29a1.149,1.149,0,1,1,1.105-1.148,1.149,1.149,0,0,1-1.105,1.148Z",
    transform: "translate(0.615 -1.628)",
    fill: "#ff5821"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSedanP);
export default __webpack_public_path__ + "static/media/sedan_p.c83e5b8ef517813606de4bdb0853b849.svg";
export { ForwardRef as ReactComponent };